/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProfileResponse } from './';
import {
    ProfileResponseFromJSON,
    ProfileResponseFromJSONTyped,
    ProfileResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdvancedSearchResultsResponse
 */
export interface AdvancedSearchResultsResponse {
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchResultsResponse
     */
    advancedSearchQueryId: string;
    /**
     * 
     * @type {Array<ProfileResponse>}
     * @memberof AdvancedSearchResultsResponse
     */
    profiles: Array<ProfileResponse>;
}

/**
 * Check if a given object implements the AdvancedSearchResultsResponse interface.
 */
export function instanceOfAdvancedSearchResultsResponse(value: object): value is AdvancedSearchResultsResponse {
    if (!('advancedSearchQueryId' in value) || value['advancedSearchQueryId'] === undefined) return false;
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    return true;
}

export function AdvancedSearchResultsResponseFromJSON(json: any): AdvancedSearchResultsResponse {
    return AdvancedSearchResultsResponseFromJSONTyped(json, false);
}

export function AdvancedSearchResultsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchResultsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'advancedSearchQueryId': json['advancedSearchQueryId'],
        'profiles': ((json['profiles'] as Array<any>).map(ProfileResponseFromJSON)),
    };
}

export function AdvancedSearchResultsResponseToJSON(value?: AdvancedSearchResultsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'advancedSearchQueryId': value['advancedSearchQueryId'],
        'profiles': ((value['profiles'] as Array<any>).map((v) => ProfileResponseToJSON(v))),
    };
}

